import { useContext, useMemo } from 'react'

import { LabRemoteConfigKeys } from 'constants/lab'
import GeoContext from 'contexts/geoContext'
import { useLabRemoteConfig } from 'hooks/FeatureFlag/useLabRemoteConfig'
import { resolveLoyaltySpendPointsRemoteConfig } from 'loyalty/lib/loyaltySpendPoints/resolveLoyaltySpendPointsRemoteConfig'

function useLoyaltySpendPointsRemoteConfig() {
  const { currentRegionCode } = useContext(GeoContext)
  const payload = useLabRemoteConfig(LabRemoteConfigKeys.loyaltySpendPointsPage)

  return useMemo(
    () => resolveLoyaltySpendPointsRemoteConfig(payload, currentRegionCode),
    [currentRegionCode, payload],
  )
}

export default useLoyaltySpendPointsRemoteConfig
